import React, { ReactElement } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import InputMask from '../InputMask/InputMask';
import { Button} from 'antd';
import { useLocation, withRouter } from 'react-router-dom';
import { getIsPageNameNewAdmission, getIsPageNameEdit, getIsPageNameEditDischarge, getIsPageNameReconsider } from '../../../../modules/crm/inPatient/service/crmUtils';
import { EditOutlined } from '@ant-design/icons';

const FormAdhaarInput = (props: any): ReactElement => {
  const { mask, regxvalidator } = props;
  const formConfig = useGetFormConfig(props);
  const { disabled, rules, buttonDisabled, buttonLoading, onButtonClickHandler,
    placeholder, buttonLabel, allowClear, key, showVerified, onChange, onEdit } = formConfig;
  const { pathname } = useLocation();
  if (regxvalidator) {
    rules.push({
      pattern: new RegExp(regxvalidator),
      message: `Please enter in desired format`,
    });
  }
  return <>
    <FormItem formConfig={formConfig} >
      <InputMask {...props}
        data-testid={key}
        allowClear={allowClear}
        mask={mask}
        placeholder={placeholder}
        disabled={disabled}
        showVerified={showVerified}
        onChange={onChange}
        maskChar=" " />
    </FormItem>
    <div>
      {showVerified && (
        <EditOutlined
          className="kyc-editbtn"
          onClick={onEdit(key)}
        />
      )}
    </div>
    {(getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) ||
      getIsPageNameReconsider(pathname) || getIsPageNameNewAdmission(pathname)) &&
      <div>
        <Button
          onClick={onButtonClickHandler}
          loading={buttonLoading}
          disabled={buttonDisabled}
        >
          {buttonLabel}
        </Button>
      </div>
    }
  </>;
};

export default withRouter(FormAdhaarInput);
